import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola Config AE
 * @namespace ConfigAESvc
 */
export default {
  /**
   * Mendapatkan semua data Config AE
   * @function getConfigAE
   * @return {Promise} Promise yang berisi response dari server
   */
  getConfigAE: async (params) => {
    const { data } = await axiosInstance.get('/master/config_ae', {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Mendapatkan data Config AE berdasarkan ID
   * @function getConfigAEById
   * @param {number} id - ID dari Config AE yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getConfigAEById: async (id) => {
    const { data } = await axiosInstance.get(`/master/config_ae/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Membuat data Config AE baru
   * @function createConfigAE
   * @param {object} configAEData - Data yang ingin di buat
   * @return {Promise} Promise yang berisi response dari server
   */
  createConfigAE: async (configAEData) => {
    const { data } = await axiosInstance.post('/master/config_ae', configAEData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Mengupdate data Config AE yang sudah ada
   * @function updateConfigAE
   * @param {number} id - ID dari Config AE yang ingin di update
   * @param {object} configAEData - Data yang ingin di update
   * @return {Promise} Promise yang berisi response dari server
   */
  updateConfigAE: async (id, configAEData) => {
    const { data } = await axiosInstance.put(`/master/config_ae/${id}`, configAEData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Menghapus data Config AE yang sudah ada
   * @function deleteConfigAE
   * @param {number} id - ID dari Config AE yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  deleteConfigAE: async (id) => {
    const { data } = await axiosInstance.delete(`/master/config_ae/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
